import { checkPermission, getLocation, Permission } from '@utils/nativeUtils';
import { useEffect } from 'react';

import useNativeListener from './useNativeListener';

interface ILocation {
    lat: number,
    lon: number,
}

interface Props {
    deps?: any[];
    enabled?: boolean;
    callbackFn?: (data: ILocation) => void;
}

function useLocation({ deps, enabled = true, callbackFn }:Props) {
    useNativeListener('getLocation', (result: ILocation) => {
        console.log('web: getLocation', result);
        callbackFn?.(result);
    });

    useNativeListener('checkPermission', (permission: Permission, hasPermission: boolean) => {
        console.log('web: check permission', { permission, hasPermission });
        if (permission === 'LOCATION' && hasPermission) {
            getLocation();
        }
    });

    useEffect(() => {
        if (enabled) {
            checkPermission(Permission.LOCATION);
        }
    }, [enabled, ...(deps || [])]);
}

export default useLocation;
